import { API, axiosInstance } from "lib";

export const addNewLrSeries = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'add_lr_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getLrSeriesListData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'get_lr_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const deleteLrSeriesData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'delete_lr_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const setLrSeriesData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'set_lr_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const updateLrSeriesData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'update_lr_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

/// Trip Series 

export const addNewTripSeries = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'add_trip_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getTripSeriesListData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'get_trip_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const deleteTripSeriesData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'delete_trip_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const setTripSeriesData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'set_trip_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const updateTripSeriesData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'update_trip_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const getInvoiceSeriesListData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'get_billraise_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const deleteInvoiceSeriesData = (data={}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'delete_billraise_series' , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const updateInvoiceSeriesData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'update_billraise_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const addNewInvoiceSeries = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'add_billraise_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};

export const setInvoiceSeriesData = (data = {}) => {
  return axiosInstance
    .post(API.GET_BRANCH + 'set_billraise_series', data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      //      throw err;
    });
};